import * as React from 'react';

/** Material UI Packages. */
import { Tooltip, Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';

/** Material UI Icons. */
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { createQuickFilterFn } from 'shared/lib/quickFilterUtils';
import { formatOperationDateTime, parseDateToLocal } from 'shared/lib/dateFormatter';
import { customized_style } from 'shared/config/Styles';

export const getColumns = (handleDownload, handleDelete, quickFilterFn) => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },

    {
        field: 'title',
        headerName: 'Subject',
        align: 'center',
        headerAlign: 'center',
        flex: 1.5,
    },
    {
        field: 'il_trade_partner_id',
        headerName: 'Trade Partner',
        align: 'center',
        headerAlign: 'center',
        flex: 0.7,
        renderCell: (params) => {
            return params.value?.name || '';
        },
        getApplyQuickFilterFn: createQuickFilterFn,
    },
    {
        field: 'il_file',
        type: 'actions',
        headerName: 'Files',
        align: 'center',
        headerAlign: 'center',
        flex: 0.1,
        getActions: ({ row }) => {
            return [
                <Tooltip title="Download">
                    <GridActionsCellItem
                        sx={{
                            bgcolor: '#003a52',
                            color: 'white',
                            '&:hover': { color: '#003a52' },
                            p: '5px',
                        }}
                        icon={<DownloadIcon sx={{ fontSize: '13px' }} />}
                        onClick={() => handleDownload(row)}
                        label="Download"
                        color="inherit"
                    />
                </Tooltip>,
            ];
        },
    },
    {
        field: 'quote_date',
        headerName: 'Quote Date',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        valueGetter: (params) => {
            if (params != null) {
                // The cell must show the day written on the quotation, in any office
                // timezone — raw new Date() reads "YYYY-MM-DD" as UTC midnight and
                // shows the previous day to the LA operations team.
                const date = parseDateToLocal(params);
                if (!date) return null;
                // MM/DD/YY format search.
                return date.toLocaleDateString('en-US', {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                });
            } else {
                return null;
            }
        },
        renderCell: (params) => {
            if (params.value != null) {
                return <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>;
            } else return null;
        },
    },
    {
        field: 'il_user_id',
        headerName: 'Created By',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
    },
    {
        field: 'modified_on',
        headerName: 'Created On',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        valueGetter: (params) => {
            if (params == null) return null;
            // 등록 시점을 근무지(LA) 날짜로 보여줘, 한국에서 열어도 같은 날짜로 검색된다.
            return formatOperationDateTime(params, 'MM/DD/YY') || null;
        },
        renderCell: (params) => {
            if (params.value != null) {
                return <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>;
            } else return null;
        },
    },
    {
        field: 'delete',
        type: 'actions',
        align: 'center',
        headerAlign: 'center',
        flex: 0.1,
        getActions: ({ row }) => {
            return [
                <Tooltip title="Delete">
                    <GridActionsCellItem
                        sx={{
                            bgcolor: '#003a52',
                            color: 'white',
                            '&:hover': { color: '#003a52' },
                            p: '5px',
                        }}
                        icon={<DeleteIcon sx={{ fontSize: '13px' }} />}
                        label="Delete"
                        onClick={() => handleDelete(row.id)}
                        color="secondary"
                    />
                </Tooltip>,
            ];
        },
    },
];
